import { render, staticRenderFns } from "./AddUpdateForum.vue?vue&type=template&id=28fa8a76&"
import script from "./AddUpdateForum.vue?vue&type=script&lang=js&"
export * from "./AddUpdateForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports